import React from "react";

import { cn } from "src/util/cn";

export const TyreParticles: React.FC = () => {
  return (
    <div
      className={cn(
        "pointer-events-none absolute inset-0 -z-10",
        "bg-[radial-gradient(circle_at_top,_#ffffff,_#e1e1e1_45%,_#d0d0d0)]"
      )}
    />
  );
};

export default TyreParticles;

